/* eslint-disable no-class-assign */
import React from 'react'
import { Link } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import grey from '@material-ui/core/colors/grey'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import LinearProgress from '@material-ui/core/LinearProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Paper from '@material-ui/core/Paper'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import { lighten } from '@material-ui/core/styles/colorManipulator'
import Switch from '@material-ui/core/Switch'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'

import classNames from 'classnames'
import Cookie from 'js-cookie'
import moment from 'moment'
import PropTypes from 'prop-types'

import { getPath } from '../../oakra/components/base-app'
import { patch } from '../../tools/request'
import { stableSort, getSorting } from '../../tools/table-tools'
import { copyObject } from '../../tools/utils'

const toolbarStyles = (theme) => ({
    root: {
        paddingRight: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        minHeight: 67,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                  color: theme.palette.secondary.main,
                  backgroundColor: lighten(theme.palette.secondary.light, 0.85),
              }
            : {
                  color: theme.palette.text.primary,
                  backgroundColor: theme.palette.secondary.dark,
              },
    spacer: {
        flex: '1 1 auto',
    },
    actions: {
        color: theme.palette.text.secondary,
        display: 'flex',
    },
    progress: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
    },
    topPagination: {
        width: 200,
    },
    title: {
        flex: '0 0 auto',
        marginTop: 8,
    },
    toolbarItems: {
        display: 'flex',
        alignItems: 'baseline',
    },
    storeSelector: {
        width: 200,
    },
    statusSelector: {
        marginLeft: 20,
    },
    storeSelectorSelect: {
        height: 38,
    },
    statusSelectorSelect: {
        height: 38,
    },
    addButton: {
        height: 38,
        alignSelf: 'center',
        width: 175,
    },
})

const styles = (theme) => ({
    root: {
        width: '100%',
        position: 'relative',
    },
    toolbar: {
        position: 'fixed',
    },
    table: {
        width: '100%',
        tableLayout: 'fixed',
    },
    tableHeader: {
        borderTop: '1px solid ' + grey[200],
    },
    tableCell: {
        padding: '0 12px',
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    checkboxColumnHeader: {
        width: 70,
    },
    checkboxRowCell: {
        padding: '0 12px',
    },
    adjustmentGroupLink: {
        textDecoration: 'none',
        color: 'inherit',
    },
    createStockAdjustmentGroupLink: {
        textDecoration: 'none',
        color: 'inherit',
    },
    noStockAdjustmentGroupsMessage: {
        textAlign: 'center',
        padding: 75,
        paddingRight: 51,
    },
    noStockAdjustmentGroupsIcon: {
        width: 100,
        height: 100,
        color: grey[300],
    },
    noStockAdjustmentGroupsText: {
        color: grey[400],
    },
    tableAddButton: {
        marginTop: 20,
    },
})

const shouldDisableDelete = (adjustmentGroupStartTime) => {
    if (!adjustmentGroupStartTime) return false

    const startTime = moment(adjustmentGroupStartTime)
    const now = moment()

    const duration = moment.duration(now.diff(startTime)).asMinutes()
    return duration < 60 && duration > 0
}

class StoreSelector extends React.PureComponent {
    render() {
        const { classes } = this.props
        return (
            <FormControl className={classes.storeSelector} variant="outlined">
                <InputLabel>{gettext('Store')}</InputLabel>
                <Select
                    className={classes.storeSelectorSelect}
                    value={this.props.selectedStoreID}
                    onChange={this.props.storeChangeHandler}
                    input={<OutlinedInput labelWidth={100} />}
                >
                    <MenuItem value="all" key="all">
                        {pgettext('all stores', 'All')}
                    </MenuItem>
                    {this.props.stores.map((store) => (
                        <MenuItem value={store.id} key={store.id}>
                            {store.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )
    }
}

StoreSelector = withStyles(toolbarStyles)(StoreSelector)

const columns = [
    { id: 'name', align: 'left', label: gettext('Name'), sort: true, width: 250 },
    {
        id: 'store__name',
        align: 'left',
        label: gettext('Store'),
        sort: true,
        visible: (props) => props.showStoreName,
    },
    { id: 'start_date', align: 'left', label: gettext('Start date'), sort: true },
    { id: 'end_date', align: 'left', label: gettext('End date'), sort: true },
    {
        id: 'status',
        align: 'left',
        label: gettext('Status'),
        sort: true,
        visible: (props) => props.showStatus,
    },
    { id: 'num_items', align: 'left', label: gettext('# of items'), sort: true },
    { id: 'active', align: 'left', label: gettext('Active'), sort: false, width: 100 },
]

class GroupsTableHead extends React.PureComponent {
    createSortHandler(property) {
        return (event) => {
            this.props.onRequestSort(event, property)
        }
    }

    render() {
        const { onSelectAllClick, order, orderBy, numSelected, rowCount, classes } = this.props

        return (
            <TableHead className={classes.tableHeader}>
                <TableRow>
                    <TableCell className={classes.tableCell} style={{ width: 70 }}>
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={rowCount !== 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                    {columns.map((column) => {
                        const colVisible = column.visible
                            ? typeof column.visible == 'function'
                                ? column.visible(this.props)
                                : column.visible
                            : true
                        return (
                            colVisible && (
                                <TableCell
                                    hidden={
                                        column.visible
                                            ? typeof column.visible == 'function'
                                                ? !column.visible(this.props)
                                                : !!column.visible
                                            : false
                                    }
                                    className={classes.tableCell}
                                    key={column.id}
                                    align={column.align}
                                    sortDirection={
                                        orderBy.replace('-', '') === column.id &&
                                        (orderBy.startsWith('-') ? 'desc' : 'asc')
                                    }
                                    width={column.width}
                                >
                                    {column.sort ? (
                                        <TableSortLabel
                                            active={orderBy.replace('-', '') === column.id}
                                            direction={orderBy.startsWith('-') ? 'desc' : 'asc'}
                                            onClick={this.createSortHandler(column.id)}
                                        >
                                            {column.label}
                                        </TableSortLabel>
                                    ) : (
                                        column.label
                                    )}
                                </TableCell>
                            )
                        )
                    }, this)}
                </TableRow>
            </TableHead>
        )
    }
}

GroupsTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
}

GroupsTableHead = withStyles(styles)(GroupsTableHead)

class StatusSelector extends React.PureComponent {
    render() {
        const { classes, selectedStatus, handleStatusSelectorChange } = this.props
        const allStatuses = ['expired', 'current', 'upcoming']

        return (
            <FormControl className={classes.statusSelector} variant="outlined">
                <InputLabel>{gettext('Status')}</InputLabel>
                <Select
                    className={classes.statusSelectorSelect}
                    value={selectedStatus}
                    onChange={handleStatusSelectorChange}
                    input={<OutlinedInput labelWidth={100} />}
                >
                    <MenuItem value="all" key="all">
                        All
                    </MenuItem>
                    {allStatuses.map((status) => (
                        <MenuItem key={status} value={status}>
                            {gettext(status).charAt(0).toUpperCase() + gettext(status).slice(1)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )
    }
}

StatusSelector = withStyles(toolbarStyles)(StatusSelector)

class GroupsTableToolbar extends React.PureComponent {
    render() {
        const {
            numSelected,
            selectedStoreID,
            handleShopChange,
            handleStatusSelectorChange,
            selectedStatus,
            handleChangePage,
            handleDelete,
            handleNewGroupClick,
            stores,
            page,
            count,
            classes,
            loading,
        } = this.props

        return (
            <Toolbar
                className={classNames(classes.root, {
                    [classes.highlight]: numSelected > 0,
                })}
            >
                {this.props.loading && (
                    <LinearProgress className={classes.progress} color="secondary" />
                )}
                <div className={classes.title}>
                    {numSelected > 0 ? (
                        <Typography color="inherit" variant="subtitle1">
                            {interpolate(pgettext('Number selected', '%s selected'), [numSelected])}
                        </Typography>
                    ) : (
                        <div className={classes.toolbarItems}>
                            <StoreSelector
                                selectedStoreID={selectedStoreID}
                                stores={stores}
                                storeChangeHandler={handleShopChange}
                            />
                            <StatusSelector
                                selectedStatus={selectedStatus}
                                handleStatusSelectorChange={handleStatusSelectorChange}
                            />
                        </div>
                    )}
                </div>
                <div className={classes.spacer} />
                <div className={classes.actions}>
                    {numSelected > 0 ? (
                        <React.Fragment>
                            <Button color="secondary" onClick={handleDelete}>
                                {ngettext(
                                    'Delete adjustment group',
                                    'Delete adjustment groups',
                                    numSelected
                                )}
                            </Button>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {stores.length == 1 ? (
                                <Button
                                    component={Link}
                                    to={getPath('createStockAdjustmentGroup').replace(
                                        'store_id',
                                        stores[0].id
                                    )}
                                    target="_blank"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.addButton}
                                >
                                    <AddIcon />
                                    {gettext('New group')}
                                </Button>
                            ) : (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.addButton}
                                    onClick={handleNewGroupClick}
                                >
                                    <AddIcon />
                                    {gettext('New group')}
                                </Button>
                            )}
                            <TablePagination
                                className={classes.topPagination}
                                component="div"
                                count={count}
                                rowsPerPage={25}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': gettext('Previous'),
                                }}
                                nextIconButtonProps={{
                                    'aria-label': gettext('Next'),
                                }}
                                onPageChange={handleChangePage}
                                rowsPerPageOptions={[25]}
                            />
                        </React.Fragment>
                    )}
                </div>
            </Toolbar>
        )
    }
}

GroupsTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
}

GroupsTableToolbar = withStyles(toolbarStyles)(GroupsTableToolbar)

class StockAdjustmentGroups extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            orderBy: '-start_date',
            selected: [],
            rowsPerPage: 25,
            selectedStoreID: 'all',
            adjustmentGroups: [],
            count: 0,
            page: 0,
            maxPageFetched: 0,
            deleteConfirmOpen: false,
            newProductSelectShopOpen: false,
            loading: true,
            selectedStatus: 'all',
        }

        this.fetchStockAdjustmentGroupsData = this.fetchStockAdjustmentGroupsData.bind(this)
        this.getDataURL = this.getDataURL.bind(this)
        this.handleShopChange = this.handleShopChange.bind(this)
        this.handleStatusSelectorChange = this.handleStatusSelectorChange.bind(this)
        this.handleSort = this.handleSort.bind(this)
        this.handleSelectAllClick = this.handleSelectAllClick.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleChecked = this.handleChecked.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.handleNewGroupClick = this.handleNewGroupClick.bind(this)
        this.handleNewGroupSelectShopClose = this.handleNewGroupSelectShopClose.bind(this)
        this.isSelected = this.isSelected.bind(this)
    }

    componentDidMount() {
        this.fetchStockAdjustmentGroupsData(this.getDataURL(), false)
    }

    addStoresInfoToStockAdjustmentGroupsData(data) {
        const { stores } = this.props,
            storesById = stores.reduce((allById, store) => {
                allById[store.id] = store
                return allById
            }, {})
        return data.map((adjustmentGroup) => {
            return { ...adjustmentGroup, storeName: storesById[adjustmentGroup.store].name }
        })
    }

    fetchStockAdjustmentGroupsData(url, replace, page = null, searchTerm = null) {
        if (!url.includes('order_by')) {
            url += '?order_by=' + this.state.orderBy
        }

        if (this.state.selectedStatus != 'all') {
            url += '&status=' + this.state.selectedStatus
        }
        if (!url.includes('store_pk') && this.state.selectedStoreID !== 'all') {
            url += '&store_pk=' + this.state.selectedStoreID
        }

        return fetch(url)
            .then((response) => response.json())
            .then((data) => {
                let adjustmentGroups

                data = this.addStoresInfoToStockAdjustmentGroupsData(data)

                if (replace) {
                    adjustmentGroups = data
                } else {
                    adjustmentGroups = copyObject(this.state.adjustmentGroups).concat(data)
                }

                const newState = {
                    count: adjustmentGroups.length,
                    adjustmentGroups: adjustmentGroups,
                    loading: false,
                }

                if (page === 0) {
                    newState['page'] = 0
                    newState['maxPageFetched'] = 0
                } else if (page > 0) {
                    newState['page'] = page
                }

                this.setState(newState)
            })
    }

    getDataURL() {
        const { stockAdjustmentGroupsAPIURL } = this.props
        return stockAdjustmentGroupsAPIURL
    }

    handleShopChange(e) {
        this.setState(
            {
                selectedStoreID: e.target.value,
                loading: true,
            },
            () => {
                this.fetchStockAdjustmentGroupsData(this.getDataURL(), true, 0)
            }
        )
    }

    handleStatusSelectorChange(e) {
        this.setState(
            {
                selectedStatus: e.target.value,
                loading: true,
            },
            () => {
                this.fetchStockAdjustmentGroupsData(this.getDataURL(), true, 0)
            }
        )
    }

    handleSort(event, property) {
        let orderBy

        if (this.state.orderBy.startsWith('-') && this.state.orderBy.replace('-', '') == property) {
            orderBy = property
        } else {
            orderBy = '-' + property
        }

        this.setState(
            {
                orderBy,
            },
            () => {
                this.fetchStockAdjustmentGroupsData(this.getDataURL(), true, 0)
            }
        )
    }

    handleSelectAllClick(event, checked) {
        if (checked) {
            this.setState((state) => ({ selected: this.state.adjustmentGroups.map((d) => d.id) }))
            return
        } else {
            this.setState({ selected: [] })
        }
    }

    handleClick(event, id) {
        console.log('handleClick', event, id)
    }

    handleChecked(event, checked, adjustmentGroupId) {
        const { selected } = this.state
        let newSelected = [...selected]

        if (checked) {
            if (!selected.includes(adjustmentGroupId)) {
                newSelected.push(adjustmentGroupId)
            }
        } else {
            newSelected = newSelected.filter((id) => id != adjustmentGroupId)
        }

        this.setState({ selected: newSelected })
    }

    handleChangePage(event, page) {
        let pageChangeURL = this.getDataURL()
        const needsFetch = page > this.state.maxPageFetched

        this.setState({
            page: page,
        })
    }

    handleDeleteConfirmClose(confirm) {
        const { stockAdjustmentGroupAPIURL } = this.props
        let adjustmentGroups = copyObject(this.state.adjustmentGroups)
        const selected = copyObject(this.state.selected)

        return (event) => {
            if (confirm) {
                adjustmentGroups = adjustmentGroups.filter((d) => !selected.includes(d.id))

                let stateToSet = {
                    selected: [],
                    count: adjustmentGroups.length,
                    adjustmentGroups: adjustmentGroups,
                    deleteConfirmOpen: false,
                }

                if (
                    this.state.page > 0 &&
                    (this.state.page + 1) * this.state.rowsPerPage > adjustmentGroups.length
                ) {
                    stateToSet['page'] = this.state.page - 1
                }

                this.setState(stateToSet, () => {
                    selected.forEach((adjustmentGroupID) => {
                        fetch(
                            stockAdjustmentGroupAPIURL.replace(
                                'stock_adjustment_group_pk',
                                adjustmentGroupID
                            ),
                            {
                                method: 'DELETE',
                                headers: {
                                    'Content-Type': 'application/json; charset=utf-8',
                                    'X-CSRFToken': Cookie.get('csrftoken'),
                                },
                            }
                        ).catch((error) => {
                            console.log(error)
                        })
                    })
                })
            } else {
                this.setState({ deleteConfirmOpen: false })
            }
        }
    }

    handleDelete() {
        this.setState({
            deleteConfirmOpen: true,
        })
    }

    handleNewGroupClick() {
        this.setState({
            newProductSelectShopOpen: true,
        })
    }

    handleNewGroupSelectShopClose() {
        this.setState({
            newProductSelectShopOpen: false,
        })
    }

    handleActiveSwitch = (adjustmentGroupId, checked) => {
        console.log('handleActiveSwitch', adjustmentGroupId, checked)
        const { stockAdjustmentGroupAPIURL } = this.props
        const payload = {
            is_active: checked,
        }
        let adjustmentGroups = this.state.adjustmentGroups.map((adjustmentGroup) => {
            if (adjustmentGroup.id === adjustmentGroupId) {
                return { ...adjustmentGroup, is_active: checked }
            }
            return { ...adjustmentGroup }
        })

        this.setState(
            {
                adjustmentGroups,
            },
            () => {
                patch(
                    stockAdjustmentGroupAPIURL.replace(
                        'stock_adjustment_group_pk',
                        adjustmentGroupId
                    ),
                    payload
                )
                    .then((response) => {
                        console.log('update adjustment group', response)
                    })
                    .catch((error) => {
                        console.log('update adjustment group error', error)
                    })
            }
        )
    }

    isSelected(adjustmentGroupID) {
        return this.state.selected.includes(adjustmentGroupID)
    }

    render() {
        const { classes, language, stores } = this.props
        const { order, orderBy, selected, rowsPerPage, page } = this.state

        const displayedStockAdjustmentGroups = stableSort(
            this.state.adjustmentGroups,
            getSorting(orderBy)
        ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)

        moment.locale(language)

        return (
            <React.Fragment>
                <Paper className={classes.root}>
                    <GroupsTableToolbar
                        className={classes.toolbar}
                        numSelected={selected.length}
                        selectedStoreID={this.state.selectedStoreID}
                        stores={this.props.stores}
                        handleShopChange={this.handleShopChange}
                        handleStatusSelectorChange={this.handleStatusSelectorChange}
                        selectedStatus={this.state.selectedStatus}
                        handleChangePage={this.handleChangePage}
                        handleDelete={this.handleDelete}
                        handleNewGroupClick={this.handleNewGroupClick}
                        count={this.state.count}
                        page={this.state.page}
                        loading={this.state.loading}
                    />
                    <div className={classes.tableWrapper}>
                        <Table className={classes.table} aria-labelledby="tableTitle">
                            <GroupsTableHead
                                className={classes.tableHead}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleSort}
                                rowCount={this.state.adjustmentGroups.length}
                                showStoreName={this.state.selectedStoreID == 'all'}
                                showStatus={this.state.selectedStatus == 'all'}
                            />
                            <TableBody>
                                {!this.state.loading && this.state.adjustmentGroups.length == 0 && (
                                    <TableRow>
                                        <TableCell
                                            colSpan={7}
                                            className={classNames(
                                                classes.noStockAdjustmentGroupsMessage,
                                                classes.tableCell
                                            )}
                                        >
                                            <LocalOfferIcon
                                                className={classes.noStockAdjustmentGroupsIcon}
                                            />
                                            <Typography
                                                className={classes.noStockAdjustmentGroupsText}
                                                variant="subtitle1"
                                            >
                                                {gettext('No groups to display')}
                                            </Typography>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                className={classes.tableAddButton}
                                                onClick={this.handleNewGroupClick}
                                            >
                                                <AddIcon />
                                                {gettext('New group')}
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                )}
                                {displayedStockAdjustmentGroups.map((adjustmentGroup) => {
                                    const isSelected = this.isSelected(adjustmentGroup.id)
                                    const detailPageLink = getPath('stockAdjustmentGroup').replace(
                                        'stock_adjustment_group_pk',
                                        adjustmentGroup.id
                                    )
                                    return (
                                        <TableRow
                                            hover
                                            onClick={(event) =>
                                                this.handleClick(event, adjustmentGroup.id)
                                            }
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={adjustmentGroup.id}
                                            selected={isSelected}
                                        >
                                            <TableCell
                                                padding="checkbox"
                                                className={classes.tableCell}
                                            >
                                                <Checkbox
                                                    checked={isSelected}
                                                    onChange={(event, checked) =>
                                                        this.handleChecked(
                                                            event,
                                                            checked,
                                                            adjustmentGroup.id
                                                        )
                                                    }
                                                    disabled={shouldDisableDelete(
                                                        adjustmentGroup.start_date
                                                    )}
                                                />
                                            </TableCell>

                                            <TableCell
                                                scope="row"
                                                padding="none"
                                                className={classes.tableCell}
                                            >
                                                <Link
                                                    to={detailPageLink}
                                                    className={classes.adjustmentGroupLink}
                                                >
                                                    <Typography noWrap={true} variant="body2">
                                                        {adjustmentGroup.name}
                                                    </Typography>
                                                </Link>
                                            </TableCell>
                                            {this.state.selectedStoreID == 'all' && (
                                                <TableCell
                                                    scope="row"
                                                    padding="none"
                                                    className={classes.tableCell}
                                                >
                                                    <Link
                                                        to={detailPageLink}
                                                        className={classes.adjustmentGroupLink}
                                                    >
                                                        <Typography noWrap={true} variant="body2">
                                                            {adjustmentGroup.storeName}
                                                        </Typography>
                                                    </Link>
                                                </TableCell>
                                            )}
                                            <TableCell className={classes.tableCell}>
                                                <Link
                                                    to={detailPageLink}
                                                    className={classes.adjustmentGroupLink}
                                                >
                                                    <Typography noWrap={true} variant="body2">
                                                        {adjustmentGroup.start_date
                                                            ? moment(
                                                                  adjustmentGroup.start_date
                                                              ).format('lll')
                                                            : '-'}
                                                    </Typography>
                                                </Link>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Link
                                                    to={detailPageLink}
                                                    className={classes.adjustmentGroupLink}
                                                >
                                                    <Typography noWrap={true} variant="body2">
                                                        {adjustmentGroup.end_date
                                                            ? moment(
                                                                  adjustmentGroup.end_date
                                                              ).format('lll')
                                                            : '-'}
                                                    </Typography>
                                                </Link>
                                            </TableCell>
                                            {this.state.selectedStatus == 'all' && (
                                                <TableCell
                                                    scope="row"
                                                    padding="none"
                                                    className={classes.tableCell}
                                                >
                                                    <Link
                                                        to={detailPageLink}
                                                        className={classes.adjustmentGroupLink}
                                                    >
                                                        <Typography noWrap={true} variant="body2">
                                                            {gettext(adjustmentGroup.status)
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                                gettext(
                                                                    adjustmentGroup.status
                                                                ).slice(1)}
                                                        </Typography>
                                                    </Link>
                                                </TableCell>
                                            )}
                                            <TableCell className={classes.tableCell}>
                                                <Link
                                                    to={detailPageLink}
                                                    className={classes.adjustmentGroupLink}
                                                >
                                                    <Typography noWrap={true} variant="body2">
                                                        {adjustmentGroup.num_items || 0}
                                                    </Typography>
                                                </Link>
                                            </TableCell>
                                            <TableCell className={classes.tableCell}>
                                                <Switch
                                                    checked={adjustmentGroup.is_active}
                                                    onChange={(e, checked) =>
                                                        this.handleActiveSwitch(
                                                            adjustmentGroup.id,
                                                            checked
                                                        )
                                                    }
                                                    disabled={adjustmentGroup.status === 'expired'}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        component="div"
                        count={this.state.count}
                        rowsPerPage={rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': gettext('Previous'),
                        }}
                        nextIconButtonProps={{
                            'aria-label': gettext('Next'),
                        }}
                        onPageChange={this.handleChangePage}
                        rowsPerPageOptions={[25]}
                    />
                </Paper>

                <Dialog
                    open={this.state.deleteConfirmOpen}
                    onClose={this.handleDeleteConfirmClose(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {ngettext(
                            'Delete this adjustment group?',
                            'Delete these adjustment group?',
                            this.state.selected.length
                        )}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {ngettext(
                                'Do you want to delete the selected adjustment group?',
                                'Do you want to delete selected adjustment groups?',
                                this.state.selected.length
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleDeleteConfirmClose(false)} color="primary">
                            {gettext('Cancel')}
                        </Button>
                        <Button
                            onClick={this.handleDeleteConfirmClose(true)}
                            color="primary"
                            autoFocus
                        >
                            {gettext('Confirm')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.newProductSelectShopOpen}
                    onClose={this.handleNewGroupSelectShopClose}
                    fullWidth={true}
                    maxWidth="xs"
                    aria-labelledby="select-store"
                >
                    <DialogTitle id="select-store">{gettext('Select store')}</DialogTitle>
                    <div>
                        <List>
                            {stores.map((store) => (
                                <Link
                                    key={store.id}
                                    to={getPath('createStockAdjustmentGroup').replace(
                                        'store_id',
                                        store.id
                                    )}
                                    target="_blank"
                                    className={classes.createStockAdjustmentGroupLink}
                                    onClick={this.handleNewGroupSelectShopClose}
                                >
                                    <ListItem button>
                                        <ListItemText primary={store.name} />
                                    </ListItem>
                                </Link>
                            ))}
                        </List>
                    </div>
                </Dialog>
            </React.Fragment>
        )
    }
}

StockAdjustmentGroups.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(StockAdjustmentGroups)
